import React from 'react'
import styled, { keyframes } from 'styled-components'

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const themeProps = {
  default: {
    size: 20
  }
}

const Button = styled.button`
  position: relative;
  overflow: hidden;
`

const Wrapper = styled.div`
  background: rgba(148, 161, 168, .7);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
`

const Spinner = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  width: ${props => themeProps[props.theme].size}px;
  height: ${props => themeProps[props.theme].size}px;
  margin-top: -${props => themeProps[props.theme].size / 2}px;
  margin-left: -${props => themeProps[props.theme].size / 2}px;
  border-radius: 50%;
  border: 2px solid ${(props) => props.color ? props.color : '#ffffff'};
  border-bottom: 2px solid transparent;
  animation: ${rotate} 1s linear infinite;
`

class ActionButton extends React.Component {
  render() {
    const { loading, children, theme, ...rest } = this.props
    return (
      <Button {...rest}>
        {
          loading ? (
            <Wrapper {...loading}>
              <Spinner theme={theme} />
            </Wrapper>
          ) : null
        }

        {children}
      </Button>
    )
  }
}

ActionButton.defaultProps = {
  theme: "default"
}

export default ActionButton
